export const QUERY_KEYS = {
  ADMIN_SELLERS_LIST: 'admin-sellers-list',
  ORDERS: 'orders',
  ORDERS_FILTERED: 'orders-filtered',
  ORDER_TRANSMISSION: 'orders-transmission',
  CLIENTS_REPORTS: 'clients-reports',
  GOALS_REPORTS: 'goals-reports',
  ORDER_PARAMS: 'order-params',
  ORDER_PARAMS_LAYOUT: 'order-params-layout',
  ORDER_FORM_OPERATION: 'order-form-operation',
}
